/**
 * This file contains helpers for direct linking, but most things are isolated to the module itself.
 * Anything exported from here should be considered for deep linking rather than general navigation.
 */
import { generatePath } from 'react-router';

export const encounterRoutes = {
  appointments: {
    path: '/appointments/*',
    build() {
      return generatePath(this.path, { '*': '' });
    },
  },
  manageAppointment: {
    path: '/appointments/:id',
    build({ id }: { id: string }) {
      return generatePath(this.path, { id });
    },
  },
  cancelAppointment: {
    path: '/appointments/:id/cancel',
    build({ id }: { id: string }) {
      return generatePath(this.path, { id });
    },
  },
  rescheduleAppointment: {
    path: '/appointments/:id/reschedule',
    build({ id }: { id: string }) {
      return generatePath(this.path, { id });
    },
  },
  newAppointment: {
    path: '/appointments/new',
    build() {
      return this.path;
    },
  },
} as const;
